<template>
  <el-card>
    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
      <span v-if="showTitle">{{title}}</span>
      <el-upload style="margin-left:20px;display: inline-block;line-height: 0;"  :accept="attachmentAccept" :before-upload="beforeUpload" :show-file-list="showFileList" ref="upload" :headers="header" :action="fileUploadUrl" :on-success="uploadSuccess" :multiple="multiple">
        <el-button type="primary">{{$t("common.upload")}}</el-button>
      </el-upload>
      <div style="display: inline-block;margin-left: 1em;">
        <slot name="header"></slot>
      </div>
    </div>
    <div v-for="(file,index) in files" :key="index" style="line-height: 40px;">
      <el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
      <el-button v-if="!disabled" @click="delFile(file,index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
    </div>
  </el-card>
</template>

<script>
import commonConstatns from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import { fileService } from "@/api/common/file-utils"
import { Message } from "element-ui";

export default {
  name: "fileUpload",
  props: {
    title: {
      type: String,
      default: 'Attachment List'
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      default: [],
    },
    recType: {
      type: String,
    },
    maxLength: {
      type: Number,
      default: null
    },
    seq: {
      type: String,
      default: null,
    },
    attachmentName: {
      type: String,
      default: '',
    },
    attachmentAccept: {
      type: String,
      default: '',
    },
    bizId: {
      type: Number,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      files: this.value,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
    }
  },
  created() {
    this.getFileList();
  },
  computed: {
    fileUploadUrl() {
      if (commonFun.isNotEmpty(this.bizId)) {
        return commonConstatns.fileUploadUrl + `/${this.recType}${this.seq == null ? '' : '/' + this.seq}/${this.bizId}/${this.attachmentName}`;
      } else {
        return commonConstatns.fileUploadUrl;
      }
    },
  },
  methods: {
    beforeUpload(file) {
      if (commonFun.isNotEmpty(this.maxLength) && commonFun.isNotEmpty(this.files)) {
        if (this.maxLength <= this.files.length) {
          Message.warning(`最多上传${this.maxLength}个文件！`);
          return false;
        }
      }
      return true;
    },
    getFileList() {
      let attachment = {};
      attachment.seq = this.seq;
      attachment.tsRecId = commonFun.isEmpty(this.bizId) ? null : this.bizId;
      attachment.tsReckindId = this.recType;
      attachment.attachmentName = this.attachmentName;
      fileService.getFileList(attachment).then(res => {
        this.files = res;
        console.log('res111111111111',this.files);
      });
    },
    uploadSuccess(response, file, fileList) {
      if (null == this.files) {
        this.files = [];
      }
      this.files.push(...(commonFun.convertToArray(response.data)));
      this.$emit("input", this.files);
      this.$emit("on-upload-success", response, file, fileList, this.files);
      this.$emit("onSuccessUpload",response)
    },
    downloadFile(file) {
      fileService.downloadFile(file);
    },
    delFile(file, fileIndex) {
      let files = this.files;
      let delIndex = null;
      let that = this;
      if (commonFun.isEmpty(file.tmDocumentId)) {
        that.$delete(that.files, fileIndex);
        that.$emit("input", that.files);
        that.$emit("on-delete-success", file, that.files);
        return;
      }
      fileService.deleteFile(file.tmDocumentId).then(res => {
        if (res.code == '200') {
          files.forEach((tmp, index) => {
            if (tmp.tmDocumentId == file.tmDocumentId) {
              delIndex = index;
              return false;
            }
          })
          that.$delete(this.files, delIndex);
          that.$emit("input", this.files);
          that.$emit("on-delete-success", file, that.files);
        }
      });
    }
  },
  watch: {
    bizId: {
      handler(newVal, oldVal) {
        this.bizId = newVal;
        this.getFileList();
      },
      immediate: true,
    },
    seq: {
      handler(newVal, oldVal) {
        this.seq = newVal;
        this.getFileList();
      },
      immediate: true,
    },
    value(newVal) {
      this.files = newVal;
    },
  }
}
</script>

<style scoped>
</style>
